import React from 'react'
import Phonecall from "../../Images/phoencalimage.png"
import Address from "../../Images/adressimage.png"
import Emailimage from "../../Images/emailimage.png"
import HomeNavbar from './HomeNavbar'
import Footer from './Footer'

function PrivacyPolicy() {
  return (
   <>
   <HomeNavbar />
      <div
          id="faqs-page"
          className="bg-white w-full py-20  text-center font-oswald mt-10"
        >
          <div className=" flex items-center justify-center">
            <p
              style={{ backgroundColor: "#EFEEFE" }}
              className="  rounded-full py-2 px-6 font-bold text-bgBlue"
            >
             P&C
            </p>
          </div>
          <br />
          <h2 className="text-3xl font-bold text-gray-900  animate-fade-in">
          Privacy  &<span className="text-purple"> Policy </span>{" "}
          </h2>
         
         

         <div className='lg:w-3/4 m-auto shadow-xl'>
         <div className="text-bgBlue p-8">
      <div className="text-start">
        <h1 className="text-4xl font-bold mb-4">Privacy Policy</h1>
        <p className="mb-4">Effective Date:30 Nov 2025</p>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Information We Collect</h2>
          <p className="mb-2">
            <strong>Personal Information:</strong> We may collect personal
            information such as your name, email address, and payment
            information when you register for an account or participate in our
            earning activities.
          </p>
          <p className="mb-2">
            <strong>Usage Data:</strong> We may collect information about your
            interaction with the app, including your IP address, browser type,
            and the pages you visit. This helps us understand user preferences
            and improve our services.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">How We Use Your Information</h2>
          <p className="mb-2">
            <strong>To Provide and Maintain the Service:</strong> We use your
            information to operate and maintain Learn2Earn24x7.
          </p>
          <p className="mb-2">
            <strong>To Communicate with You:</strong> We may use your email
            address to send you updates, promotional offers, and information
            about our services. We may also notify you of upcoming challenges,
            new features, and other relevant updates.
          </p>
          <p className="mb-2">
            <strong>To Comply with Legal Obligations:</strong> We may use your
            information to comply with applicable Indian laws and regulations,
            including tax laws and Know Your Customer (KYC) requirements.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Sharing Your Information</h2>
          <p className="mb-2">
            <strong>With Third-Party Service Providers:</strong> We may share
            your information with third-party service providers who assist us in
            operating our platform, such as payment processors or cloud hosting
            providers. These third parties are required to maintain the
            confidentiality of your information.
          </p>
          <p className="mb-2">
            <strong>For Legal Purposes:</strong> We may disclose your
            information if required by law, such as in response to a court
            order, or to protect our rights or the rights of others.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Data Security</h2>
          <p className="mb-2">
            We take data security seriously and implement reasonable measures to
            protect your information from unauthorized access, loss, misuse, or
            alteration. However, no method of transmission over the internet or
            electronic storage is 100% secure, and we cannot guarantee absolute
            security.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Your Rights</h2>
          <p className="mb-2">
            <strong>Access and Correction:</strong> You have the right to access
            and update your personal information at any time through your
            account settings. If you believe that any information we hold about
            you is inaccurate or incomplete, you can request correction.
          </p>
          <p className="mb-2">
            <strong>Data Deletion:</strong> You have the right to request the
            deletion of your personal information. Please note that we may
            retain certain information as required by law or for legitimate
            business purposes.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Children's Privacy</h2>
          <p className="mb-2">
            Learn2Earn24x7 is not intended for children under the age of 18. We do
            not knowingly collect personal information from children under 18.
            If we become aware that we have collected such information, we will
            take steps to delete it promptly.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">International Data Transfers</h2>
          <p className="mb-2">
            Your information may be transferred to and processed in countries
            outside of India. By using our service, you consent to such
            transfers, which are necessary for the performance of the service.
            We ensure that such transfers comply with applicable data protection
            laws.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Changes to This Privacy Policy</h2>
          <p className="mb-2">
            We may update this Privacy Policy from time to time to reflect
            changes in our practices or for other operational, legal, or
            regulatory reasons. We will notify users of significant changes by
            email or through our app. Your continued use of the service after
            such changes signifies your acceptance of the new policy.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Contact Information</h2>
          <p className="mb-2">
            If you have any questions about this Privacy Policy, please contact
            us at{" "}
            <a
              href="mailto:support@learn2earn24x7.com"
              className="text-blue-500 underline"
            >
              support@learn2earn24x7.com
            </a>
            .
          </p>
        </section>
      </div>
    </div>
         </div>
        </div>
        <Footer/>
   </>
  )
}

export default PrivacyPolicy
